module.exports = __webpack_public_path__ + "assets/41bd2ef751316d577f61c5eea489f068.mp3";